import React from 'react';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { WhatIsCLVN } from '../components/WhatIsCLVN';
import { Applications } from '../components/Applications';
import { VisualEngine } from '../components/VisualEngine';
import { Timeline } from '../components/Timeline';
import { Papers } from '../components/Papers';
import { Author } from '../components/Author';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="flex flex-col w-full" data-id="element-282">
      <Nav data-id="element-283" />
      <main data-id="element-284">
        <Hero data-id="element-285" />
        <div id="marco" data-id="element-286">
          <WhatIsCLVN data-id="element-287" />
        </div>
        <div id="aplicaciones" data-id="element-288">
          <Applications data-id="element-289" />
        </div>
        <div id="motor" data-id="element-290">
          <VisualEngine data-id="element-291" />
        </div>
        <div id="timeline" data-id="element-292">
          <Timeline data-id="element-293" />
        </div>
        <div id="papers" data-id="element-294">
          <Papers data-id="element-295" />
        </div>
        <div id="autor" data-id="element-296">
          <Author data-id="element-297" />
        </div>
        <div id="contacto" data-id="element-298">
          <Contact data-id="element-299" />
        </div>
      </main>
      <Footer data-id="element-300" />
    </div>;
}